
// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import "../contact.css";

// export default function ContactPage() {
//   // Form state
//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//     query: "",
//   });

//   // Handle input changes
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Handle form submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const scriptURL =
//       "https://script.google.com/macros/s/AKfycbzpLPLpy7kjSkcw2E-iGTBnsslQWihMgN08i60RWDe6raL5QZqidFOTM2bT8jRARa3yXg/exec";

//     try {
//       const res = await fetch(scriptURL, {
//         method: "POST",
//         body: JSON.stringify(formData),
//       });
//       const data = await res.json();

//       if (data.status === "success") {
//         alert("Form submitted successfully!");
//         setFormData({ fullName: "", email: "", phone: "", query: "" }); // Reset form
//       } else {
//         alert("Error submitting form");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong!");
//     }
//   };

//   return (
//     <div className="contact-wrapper">
//       {/* <motion.div
//         className="contact-banner"
//         style={{
//           height: "250px",
//           background: "linear-gradient(135deg, #41457b, #0505079a, #0505079a)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           borderRadius: "10px",
//         }}
//       >
//         <motion.h1
//           initial={{ y: 60, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           transition={{ duration: 1.2 }}
//           style={{ color: "#fff", fontSize: "40px", fontWeight: "600" }}
//         >
//           Contact Us
//         </motion.h1>
//       </motion.div> */}
//       <motion.div className="contact-banner">
//         <motion.h1
//           initial={{ y: 60, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           transition={{ duration: 1.2 }}
//         >
//           Contact Us
//         </motion.h1>
//       </motion.div>

//       <motion.div
//         className="contact-intro"
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//       >
//         {/* Optional intro text */}
//       </motion.div>

//       <div className="contact-section">
//         <motion.div
//           className="contact-details"
//           initial={{ x: -80, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.9 }}
//         >
//           <h2>Get in Touch</h2>
//           <p
//             style={{
//               marginTop: "10px",
//               lineHeight: "1.7",
//               fontSize: "16px",
//               opacity: "0.9",
//             }}
//           >
//             Your future doesn’t begin alone—it begins with a conversation. Tell
//             us what you want to achieve, explore, or build. Acadme is here with
//             answers, direction, and real-world support. Send a message and let
//             the journey toward success begin.
//           </p>
//         </motion.div>

//         <motion.form
//           className="contact-form"
//           initial={{ x: 80, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 0.9 }}
//           onSubmit={handleSubmit} // <-- submit handler add kiya
//         >
//           <label>Full Name</label>
//           <input
//             type="text"
//             name="fullName"
//             value={formData.fullName}
//             onChange={handleChange}
//             placeholder="Enter your full name"
//             required
//           />

//           <label>Email</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter your email"
//             required
//           />

//           <label>Phone Number</label>
//           <input
//             type="number"
//             name="phone"
//             value={formData.phone}
//             onChange={handleChange}
//             placeholder="Enter phone number"
//             required
//           />

//           <label>Query</label>
//           <textarea
//             name="query"
//             value={formData.query}
//             onChange={handleChange}
//             placeholder="Write your message here..."
//             required
//           ></textarea>

//           <motion.button
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.92 }}
//             type="submit"
//           >
//             Submit
//           </motion.button>
//         </motion.form>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { motion } from "framer-motion";
import "../contact.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    query: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };

    if (name === "fullName") {
      const cleanedValue = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, fullName: cleanedValue });

      if (value && value !== cleanedValue) newErrors.fullName = "Must contain only letters ";
      else delete newErrors.fullName;

      setErrors(newErrors);
      return;
    }

    if (name === "phone") {
      const cleanedValue = value.replace(/\D/g, ""); 
      if (cleanedValue.length > 10) return; 
      setFormData({ ...formData, phone: cleanedValue });

      if (value && value !== cleanedValue) newErrors.phone = "Must contain only digits";
      else delete newErrors.phone;

      setErrors(newErrors);
      return;
    }

    if (name === "email") {
      setFormData({ ...formData, email: value });
      
      if (errors.email) {
        newErrors.email = undefined;
        setErrors(newErrors);
      }
      return;
    }

    if (name === "query") {
      setFormData({ ...formData, query: value });
      if (!value.trim()) newErrors.query = "Query is required";
      else delete newErrors.query;
      setErrors(newErrors);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

   
    if (!formData.fullName.trim()) newErrors.fullName = "Name is required";

 
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email = "Invalid email format";


    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    else if (formData.phone.length !== 10) newErrors.phone = "Phone number must be exactly 10 digits";

    if (!formData.query.trim()) newErrors.query = "Query is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const scriptURL =
        "https://script.google.com/macros/s/AKfycbzpLPLpy7kjSkcw2E-iGTBnsslQWihMgN08i60RWDe6raL5QZqidFOTM2bT8jRARa3yXg/exec";

      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (data.status === "success") {
        alert("Form submitted successfully!");
        setFormData({ fullName: "", email: "", phone: "", query: "" });
        setErrors({});
      } else {
        alert("Error submitting form");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="contact-wrapper">
      <motion.div className="contact-banner">
        <motion.h1
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          Contact Us
        </motion.h1>
      </motion.div>

      <div className="contact-section">
        <motion.div
          className="contact-details"
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.9 }}
        >
          <h2>Get in Touch</h2>
          <p>
            Your future doesn’t begin alone—it begins with a conversation. Tell
            us what you want to achieve, explore, or build. Acadme is here with
            answers, direction, and real-world support. Send a message and let
            the journey toward success begin.
          </p>
        </motion.div>

        <motion.form
          className="contact-form"
          initial={{ x: 80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.9 }}
          onSubmit={handleSubmit}
        >
          <label>Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Enter your full name"
          />
          {errors.fullName && <p className="error">{errors.fullName}</p>}

          <label>Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
          />
          {errors.email && <p className="error">{errors.email}</p>}

          <label>Phone Number</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />
          {errors.phone && <p className="error">{errors.phone}</p>}

          <label>Query</label>
          <textarea
            name="query"
            value={formData.query}
            onChange={handleChange}
            placeholder="Write your message here..."
          />
          {errors.query && <p className="error">{errors.query}</p>}

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.92 }}
            type="submit"
          >
            Submit
          </motion.button>
        </motion.form>
      </div>
    </div>
  );
}
